import { Vendor } from "@/core";

type VendorDisplayFields = Pick<
  Vendor,
  | "companyName"
  | "firstName"
  | "lastName"
  | "email"
  | "phone"
  | "secondaryEmail"
  | "secondaryPhone"
>;

export function getVendorFullName({
  vendor,
}: {
  vendor: Pick<VendorDisplayFields, "firstName" | "lastName">;
}) {
  return `${vendor.firstName} ${vendor.lastName}`.trim();
}

export function getVendorDisplayName({
  vendor,
}: {
  vendor: Pick<
    VendorDisplayFields,
    "companyName" | "firstName" | "lastName" | "email"
  >;
}) {
  const companyName = vendor.companyName?.trim() || "";
  const fullName = getVendorFullName({ vendor });

  return [companyName, fullName].filter(Boolean).join(" · ") || vendor.email?.trim() || "Vendor";
}

export function getVendorSearchKeywords({
  vendor,
}: {
  vendor: VendorDisplayFields;
}) {
  return [
    vendor.companyName,
    vendor.firstName,
    vendor.lastName,
    vendor.email,
    vendor.phone,
    vendor.secondaryEmail,
    vendor.secondaryPhone,
  ].filter((value): value is string => Boolean(value?.trim()));
}

export function getVendorSelectLabel({
  vendor,
}: {
  vendor: Pick<
    VendorDisplayFields,
    "companyName" | "firstName" | "lastName" | "email"
  >;
}) {
  const displayName = getVendorDisplayName({ vendor });

  if (!vendor.email?.trim()) {
    return displayName;
  }

  return displayName === vendor.email ? vendor.email : `${displayName} (${vendor.email})`;
}
